// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsents_root__3OD4n","consentsList":"PatientConsents_consentsList__3rX95","consentsListEmpty":"PatientConsents_consentsListEmpty__3RZ3O"};